import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateChecklistMemberActions as Actions,
  UpdateChecklistMemberRequestAction as RequestAction,
} from 'store/ducks/checklistMembers';

export function* updateChecklistMemberRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `checklist-members/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Usuário atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}